<template>
  <div>
    <a-page-header title="班级详情" @back="back">
      <div class="df">
        <a-descriptions title="基本信息">
          <a-descriptions-item label="班级名称">{{
            courseInfo.className
          }}</a-descriptions-item>
          <a-descriptions-item label="上课地点">{{
            courseInfo.placeName
          }}</a-descriptions-item>
          <a-descriptions-item label="上课老师">{{
            courseInfo.teacherName
          }}</a-descriptions-item>
          <a-descriptions-item label="课程提供方">{{
            courseInfo.providerName
          }}</a-descriptions-item>
          <a-descriptions-item label="上课日期">{{ courseInfo.startClassDate
          }}{{
              courseInfo.endClassDate ? '~' + courseInfo.endClassDate : ''
            }}</a-descriptions-item>
          <a-descriptions-item label="上课计划">
            <div v-for="(item, index) in courseInfo.teachingPlanList" :key="index">
              <span>{{ item.classWeeks | weekName }}&nbsp;&nbsp;</span>
              <span>{{ item.classTime }}</span>
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="排课类型">{{
            courseInfo.flexibleSchedule == 0
              ? '固定排课'
              : courseInfo.flexibleSchedule == 1
                ? '灵活排课'
                : ''
          }}</a-descriptions-item>
          <a-descriptions-item label="班级状态"><a class="ant-descriptions-item-label"
              @click="startRestore(courseInfo.id, courseInfo.status == 1)">{{
                courseInfo.status == 0
                  ? '预开班'
                  : courseInfo.status == 1
                    ? '已开班'
                    : courseInfo.status == 2
                      ? '已取消'
                      : courseInfo.status == 3
                        ? '已停用'
                        : courseInfo.status == -1
                          ? '待发布'
                          : ''
              }}</a></a-descriptions-item>
        </a-descriptions>
        <div class="qr-code" v-if="qrCode">
          <div class="pic">
            <img :src="qrCode">
          </div>
          <a-button style="width: 100%;" type="primary" @click="downloadQrCode" :loading="isDownload">
            {{ isDownload ? '下载中...' : '下载二维码' }}
          </a-button>
        </div>
      </div>
    </a-page-header>
    <div class="table-top flex-between">
      <div class="table-top-left">课节目录</div>
      <div class="table-top-right" v-if="$route.query.status !== '3'">
        <a-button type="primary" style="margin-right: 10px" :disabled="courseInfo.status != 1"
          @click="batchChangeClass(changeBatches)">批量改课</a-button>
        <a-button type="primary" :disabled="courseInfo.status != 1" style="margin-right: 10px"
          @click="deleteClass(deleteBatches)">批量删除</a-button>

        <a-button type="primary" @click="visible = true" :disabled="courseInfo.status != 1">新增课节</a-button>
      </div>
    </div>
    <a-table :row-selection="{
      selectedRowKeys: selectedRowKeys,
      onChange: rowSelection,
    }" :data-source="lessonList" :columns="columns" rowKey="scheduleId" :pagination="false" :loading="tableLoading">
      <template slot="attendDate" slot-scope="value">
        {{ moment(value).format('YYYY-MM-DD 周dd') }}
      </template>
      <!-- <template slot="courseLesson" slot-scope="value, record, index">
        {{ record.classPeriodNum != 0 ? value : '补课' }}
      </template> -->
      <template slot="lessonName" slot-scope="value">
        <span>{{ value }}</span>
      </template>
      <template slot="teacherCheckinStatus" slot-scope="value">
        <span :class="teacherCheckinStatusText[value].class">{{
          teacherCheckinStatusText[value].text
        }}</span>
      </template>
      <template slot="status" slot-scope="value, record">
        <span :class="`${statusClass[value]}-round round`"></span>
        <span>{{ record.statusText }}</span>
      </template>
      <!-- 学生总人数/实到/请假 -->
      <template slot="totalCount" slot-scope="value, record">
        {{ record.totalCount }}/{{ record.checkinCount }}/{{
          record.absenceCount
        }}
      </template>
      <!-- 状态 -->
      <template slot="operation" slot-scope="value, record, index">
        <a @click="showSummary(record.scheduleId)">课节总结</a>
        <template v-if="record.scheduleId">
          <a style="margin-left: 14px" @click="updateTime(record)" v-if="record.status != 1">修改</a>
          <a style="margin-left: 14px" @click="postpone(record, index)"
            v-if="courseInfo.flexibleSchedule == 0 && record.status != 1">顺延</a>
        </template>
        <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" v-if="record.status !== 1"
          @confirm="deleteClass(record)"><a style="margin-left: 14px">删除</a></a-popconfirm>
      </template>
    </a-table>
    <a-modal title="新增课节" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="visible = false">
      <a-form-model ref="ruleForm" layout="horizontal" :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }"
        :model="xhrParams" :rules="rules">
        <a-form-model-item label="增加课节方式" prop="lessonType">
          <a-radio-group v-model="xhrParams.lessonType">
            <a-radio :value="0">自选课节</a-radio>
            <a-radio :value="1">新建课节</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <template v-if="xhrParams.lessonType === 0">
          <a-form-model-item label="目标课节" prop="scheduleId">
            <a-select v-model="xhrParams.scheduleId" placeholder="请选择" style="width: 224px">
              <a-select-option v-for="(item, index) in lessonListSelect" :key="index" :value="item.scheduleId">
                {{ item.courseLesson }}{{ item.lessonName ? ': ' + item.lessonName : '' }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </template>
        <template v-else>
          <!-- <a-form-model-item label="课节名称" prop="lessonName"
            ><a-input
              v-model="xhrParams.lessonName"
              placeholder="请输入"
              style="width: 224px"
          /></a-form-model-item> -->
        </template>
        <a-form-model-item v-if="!xhrParams.lessonType" label="增加课节日期" prop="attendDate"><a-date-picker
            v-model="xhrParams.attendDate" format="YYYY-MM-DD" style="width: 224px" /></a-form-model-item>
        <a-form-model-item v-if="!xhrParams.lessonType" label="增加课节时间" prop="classTime">
          <a-time-picker v-model="startTime" format="HH:mm" placeholder="开始时间" @change="onChange($event, 'start')" />
          <span>—</span>
          <a-time-picker v-model="endTime" format="HH:mm" placeholder="结束时间" @change="onChange($event, 'end')" />
        </a-form-model-item>
        <div class="newly-course" v-if="xhrParams.lessonType">
          <div class="newly-course-name">增加课节：</div>
          <div class="newly-course-content">
            <a-form-model-item label="">
              <a-space v-for="(item, index) in xhrParams.classTimeList" :key="item.id"
                style="display: flex; margin-bottom: 8px" align="baseline">
                <a-form :form="form2">
                  <div class="newly-increased">
                    <div
                      :class="['newly-picker', (!xhrParams.classTimeList[index].attendDate && xhrParams.classTimeList[index].startTime) || xhrParams.classTimeList[index].duplicate ? 'newly-attendDate' : '']">
                      <!-- <div> -->
                      <a-form-item>
                        <a-date-picker v-model="xhrParams.classTimeList[index].attendDate" :rules="[
                          { required: true, message: '请选择日期' }]" @change="onChangeFour($event, index, item)"
                          @focus="onFocusSelect($event, index, 'start')" format="YYYY-MM-DD" style="width: 130px"
                          :disabledDate="disabledDate" />
                      </a-form-item>
                      <span
                        v-show="!xhrParams.classTimeList[index].attendDate && xhrParams.classTimeList[index].startTime"
                        class="choice">请选择日期</span>
                      <span v-show="xhrParams.classTimeList[index].duplicate" class="choice">与已存在的课节重复</span>
                    </div>
                    <div>
                      <div class="newly-increased-classTime">
                        <div
                          :class="['form-cell', (!xhrParams.classTimeList[index].classTime && xhrParams.classTimeList[index].endTime) || xhrParams.classTimeList[index].duplicate ? 'newly-classTime' : '']">
                          <a-form-item>
                            <a-select showSearch :allowClear="true" v-model="xhrParams.classTimeList[index].classTime"
                              :class="['form-cell', xhrParams.classTimeList[index].classTime ? '' : '']"
                              placeholder="请选择上课时间" @change="onChangeThree($event, index, item)" style="width: 150px"
                              @focus="onFocusSelect($event, index, 'end')">
                              >
                              <a-select-option v-for="d in choiceRange" :key="d.classTime">{{
                                d.classTime
                              }}</a-select-option>
                            </a-select>
                          </a-form-item>
                          <span
                            v-show="!xhrParams.classTimeList[index].classTime && xhrParams.classTimeList[index].endTime"
                            class="choice">请选择时间</span>
                        </div>
                        <a-icon type="delete" @click="removeUser(item)" />
                      </div>
                    </div>
                  </div>
                </a-form>
              </a-space>
            </a-form-model-item>
            <div class="newly-add">
              <a-form-item>
                <a-button type="dashed" block @click="addUser">
                  <a-icon type="plus" />
                  添加
                </a-button>
              </a-form-item>
            </div>
          </div>
        </div>
      </a-form-model>
    </a-modal>
    <a-modal title="修改课节" :maskClosable="false" :width="500" :visible="visible_inner" :cancelText="'取消'" :okText="'确定'"
      @cancel="handleCancel_inner" @ok="handleSubmit_inner">
      <a-form-model ref="ruleForm" :model="form" :rules="formRules" class="class-form" layout="horizontal" :form="form">
        <a-form-model-item class="update-time-form" label="课节名称" :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }">
          <span>{{ updateObj.lessonName }}</span>
          <!-- <a-input v-model="form.lessonName" /> -->
        </a-form-model-item>
        <a-form-model-item class="update-time-form" label="课节码" :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }">
          <span>{{ updateObj.courseCode }}</span>
        </a-form-model-item>
        <!-- 课节日期 -->
        <a-form-model-item label="课节日期" prop="attendDate" class="update-time-form" :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }">
          <a-date-picker :value="form.attendDate" format="YYYY-MM-DD" @change="changeDate" style="width: 100%"
            :disabledDate="disabledDate_attendDate" />
        </a-form-model-item>
        <a-form-model-item class="update-time-form" prop="classTime" label="课节时间" :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 16 } }">
          <a-time-picker v-model="changestartTime" format="HH:mm" placeholder="开始时间"
            @change="changeonChange($event, 'start')" />
          <span>—</span>
          <a-time-picker v-model="changeendTime" format="HH:mm" placeholder="结束时间"
            @change="changeonChange($event, 'end')" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <ClassSummary :visible.sync="summaryVisable" ref="classSummaryRef"></ClassSummary>
    <!-- 批量改课 -->
    <a-modal :cancelText="'取消'" :okText="'确定'" :width="500" :maskClosable="false" @cancel="batchChangeCancel"
      :visible="changeVisible" title="批量改课" @ok="batchChangeOk">
      <a-form>
        <a-form-item :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }" label="更改课节数">
          {{ this.changeBatches.length }}
        </a-form-item>

        <a-form-item :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }" label="上课时间" :required="true">
          <a-select @focus="getTimeList" placeholder="请选择" v-model="time">
            <a-select-option :value="item" v-for="(item, index) in timeList" :key="index">{{ item }}</a-select-option>
          </a-select></a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import education from '../../api/education'
import qywx from '../../api/third-qywx';
import moment from 'moment'
import ClassSummary from './components/classSummary.vue';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue';
import common from '../../utils/common';
import classSet from '../../api/classSet';
export default {
  components: {
    ClassSummary,
  },
  data() {
    return {
      moment,
      statusClass: ['', 'disabled', 'success', 'warning'],
      teacherCheckinStatusText: [
        {
          class: 'disabled',
          text: '待签到',
        },
        {
          class: 'success',
          text: '已签到',
        },
        {
          class: 'warning',
          text: '请假',
        },
        //替换状态。如果没有状态返回，就显示暂无
      ],
      restoreConfirm: 0,
      columns: [
        {
          title: '日期/周期',
          key: 'attendDate',
          dataIndex: 'attendDate',
          scopedSlots: { customRender: 'attendDate' },
        },
        // {
        //   title: '上课课节',
        //   key: 'courseLesson',
        //   dataIndex: 'courseLesson',
        //   scopedSlots: { customRender: 'courseLesson' },
        // },
        {
          title: '课节名称',
          key: 'lessonName',
          dataIndex: 'lessonName',
          scopedSlots: { customRender: 'lessonName' },
        },
        {
          title: '课节码',
          key: 'courseCode',
          dataIndex: 'courseCode',
        },
        {
          title: '上课时间段',
          key: 'classTime',
          dataIndex: 'classTime',
        },
        {
          title: '考勤老师',
          key: 'teacherName',
          dataIndex: 'teacherName',
          scopedSlots: { customRender: 'teacherName' },
        },
        {
          title: '考勤时间',
          key: 'checkinTime',
          dataIndex: 'checkinTime',
          scopedSlots: { customRender: 'checkinTime' },
        },
        {
          title: '考勤次数',
          key: 'teacherCheckinCount',
          dataIndex: 'teacherCheckinCount',
          scopedSlots: { customRender: 'teacherCheckinCount' },
        },
        {
          title: '学生总人数/实到/请假',
          key: 'totalCount',
          dataIndex: 'totalCount',
          scopedSlots: { customRender: 'totalCount' },
        },
        {
          title: '状态',
          key: 'status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          key: 'operation',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      startTime: '',
      endTime: '',
      changestartTime: '',
      changeendTime: '',
      courseInfo: {},
      // lessonList: [],
      visible: false,
      confirmLoading: false,
      classId: null,
      xhrParams: {
        lessonType: 0,
        lessonId: null,
        attendDate: '',
        lessonName: '',
        classTime: '',
        scheduleId: null,
        classTimeList: [{ attendDate: '', classTime: undefined, startTime: false, endTime: false, id: Date.now() }],
      },
      form2: this.$form.createForm(this),
      rules: {
        lessonType: [
          { required: true, message: '请选择补课方式', trigger: 'change' },
        ],
        scheduleId: [
          { required: true, message: '请选择目标课节', trigger: 'change' },
        ],
        attendDate: [
          { required: true, message: '请选择时间', trigger: 'change' },
        ],
        lessonName: [
          { required: true, message: '请输入课节名称', trigger: 'blur' },
        ],
        classTime: [
          { required: true, message: '请选择补课时间', trigger: 'blur' },
        ],
        classTimeListAttendDate: [
          { required: true, message: '请选择时间', trigger: 'blur' },
        ],
      },
      summaryVisable: false,
      visible: false,
      visible_inner: false,
      confirmLoading: false,
      courseDetail: {},
      form: this.$form.createForm(this),
      toClassList: [], //上课时间段
      updateObj: {}, //修改的对象
      visible1: false, //补课
      formLayout: 'horizontal',
      lessonName: {},
      lessonList: [],
      lessonListSelect: [],
      classTime: '',
      lessonName: [],
      lessonType: 0,
      lessonId: 0,
      scheduleId: 0,
      classId: 0,
      courseId: 0,
      attendDate: '2021-07-22',
      form: {
        // lessonName: '',
        attendDate: null,
        classTime: '',
      },
      formRules: {
        // lessonName: [
        //   { required: true, message: '请输入课节名称', trigger: 'blur' },
        // ],
        attendDate: [
          { required: true, message: '请选择时间', trigger: 'change' },
        ],
        classTime: [
          { required: true, message: '请选择补课时间', trigger: 'blur' },
        ],
        attendDate: [
          { required: true, message: '请选择时间', trigger: 'change' },
        ],
        classTime: [
          { required: true, message: '请选择补课时间', trigger: 'blur' },
        ],
      },
      formRules2: {
        // lessonName: [
        //   { required: true, message: '请输入课节名称', trigger: 'blur' },
        // ],
        attendDate: [
          { required: true, message: '请选择日期', trigger: 'change' },
        ],
        classTime: [
          { required: true, message: '请选择时间时间', trigger: 'blur' },
        ],
      },
      isShow: true,
      current: '', // 页码
      deleteBatches: [], //批量删除id
      changeVisible: false,
      selectedRowKeys: [],
      updataDisabled: false,
      changeBatches: [],
      periodList: [],
      timeList: [],
      period: '',
      time: '',
      LessonPlanList: {},
      tableLoading: false, //课节目录loading
      termEndTime: '',
      errorMessage: false,
      choiceRange: [],
      allowTime: [],
      classTimeList: [],
      TimeError: false, // 开始时间大于了错误时间
      errorList: [],
      arrLessonList: new Set(),
      qrCode: '',
      isDownload: false,
    }
  },
  created() {
    this.qrCode = this.$route.query.qrCode
    this.initGetId()
    this.getnewClassFestival()
  },
  methods: {
    back() {
      if (this.$route.query.back == 'list') {
        this.$router.push('classList')
      } else {
        this.$router.go(-1)
      }
    },
    startRestore(id, check) {
      if (check) {
        this.restoreConfirm++;
        if (this.restoreConfirm >= 5) {
          let _this = this;
          this.$confirm({
            title: '确定要还原已开班到预开班？',
            content: '本班级当前是“已开班”状态，如果您需要还原到“预开班”将会删除老师签到，删除学生点名，删除已排课课节，并且无法还原！无法还原！无法还原！',
            okText: "确定(" + (8 - _this.restoreConfirm) + ")",
            onOk() {
              if (_this.restoreConfirm >= 8) {
                _this.restoreConfirm = -1000;
                _this.confirmRestore(_this, id);
              }
            },
            onCancel() { },
          })
        }
      }
    },
    confirmRestore(_this, id) {
      classSet.restoreClass(id, { confirm: true }).then(res => {
        if (res.code == 0) {
          _this.$message.success('还原预开班成功');
          _this.$router.go(-1);
        }
        else
          _this.$message.error(res.msg);
      })
    },
    rowSelection(selectedRowKeys, record) {
      this.changeBatches = record
      this.selectedRowKeys = selectedRowKeys
      this.deleteBatches = record.map((item) => {
        return item.scheduleId
      })
    },
    getTimeList() {
      education.getClassTimeList().then((res) => {
        this.timeList = res.data.map((item) => {
          return `${item.startTime}-${item.endTime}`
        })
        // this.timeList = res.data
      })
    },
    getnewClassFestival() {
      let schoolId = Vue.ls.get('schoolId')
      let classId = this.$route.query.id
      education.newClassFestival({ schoolId, id: classId }).then((res) => {
        this.termEndTime = res.data.termEndTime
        res.data.classTimeList.map((item) => {
          item.classTime = item.startTime + '-' + item.endTime
          this.choiceRange.push(item)
        })
        // this.choiceRange = res.data.classTimeList
      })
    },
    //批量改课
    batchChangeClass(record) {
      if (record.length < 2) {
        this.$message.warning('请至少选择两个课节进行修改')
      } else {
        let res = record.every((item) => {
          if (item.status == 1) {
            this.$message.error('已结束的课节不可修改')
            return false
          } else if (
            moment(item.attendDate).format('YYYY-MM-DD') ==
            moment().format('YYYY-MM-DD')
          ) {
            this.$message.error('当天的课节不可改课')
            return false
          } else {
            return true
          }
        })
        this.changeVisible = res
      }
    },
    batchChangeOk() {
      if (!this.time) {
        return
      }
      education
        .affirmLessonPlan({
          scheduleId: this.selectedRowKeys,
          classTime: this.time,
          classId: this.classId,
        })
        .then((res) => {
          this.$message.success('操作成功')
          this.changeVisible = false
          this.getDetail(this.classId)
          this.selectedRowKeys = []
          this.timeList = []
          this.time = ''
        })
    },
    batchChangeCancel() {
      this.time = ''
      this.timeList = []
      this.changeVisible = false
    },
    checkClassTime(rule, value, callback) {
      if (value === '') {
        callback(new Error('请选择补课时间'))
      } else {
        callback()
      }
    },
    initGetId() {
      const { id, courseId } = this.$route.query
      if (!id || !courseId) return
      this.classId = id
      this.courseId = courseId
      this.getDetail(id)
    },
    showSummary(id){
      this.summaryVisable = true
      this.$refs.classSummaryRef.getSummary(id)
    },
    //获取表格数据
    getDetail(id) {
      this.tableLoading = true
      education
        .getClassDetail(id)
        .then((res) => {
          this.courseInfo = res.data
          res.data.lessonList = res.data.lessonList.sort((a, b) => {
            return new Date(a.attendDate.slice(0, 10) + ' ' + a.classTime.slice(0, 5) + ':00').getTime() - new Date(b.attendDate.slice(0, 10) + ' ' + b.classTime.slice(0, 5) + ':00').getTime()
          })
          this.arrLessonList = new Set()
          this.lessonList = res.data.lessonList
          this.lessonList.map((item) => {
            //item.attendDate = item.attendDate.slice(0, 10)
            this.arrLessonList.add(item.attendDate.slice(0, 10) + '/' + item.classTime);
          })
          this.lessonListSelect = this.lessonList.filter(item => item.classPeriodNum !== 0)
          this.getClassTimeList()
          if (
            this.$route.query.isReport &&
            this.$route.query.isReport !== '[object Object]' &&
            this.isShow
          ) {
            this.showSummary()
          }
        })
        .finally((res) => {
          this.tableLoading = false
        })
    },
    // 发送请求数据
    async sendParamsClass(res) {
      const data = await education.makeUpMissedLessons(res)
      if (data.code === 0) {
        this.getDetail(this.classId)
        this.visible = false
        this.xhrParams.classTimeList = [{ attendDate: '', classTime: undefined, startTime: '', endTime: '', id: Date.now(), duplicate: false }]
      }
    },
    onChange(time, type) {
      this[`${type}Time`] = time
      if (!time) {
        this.xhrParams.classTime = ''
        this.$refs.ruleForm.validateField('classTime')
      }
      if (this.startTime && this.endTime && this.startTime >= this.endTime) {
        this.$message.error('结束时间必须大于开始时间')
      } else if (this.startTime && this.endTime) {
        const startTime = this.startTime
          ? moment(this.startTime).format('HH:mm')
          : ''
        const endTime = this.endTime ? moment(this.endTime).format('HH:mm') : ''
        this.xhrParams.classTime = `${startTime}-${endTime}`
        this.$refs.ruleForm.clearValidate('classTime')
      }
    },
    onChangeTwo(time, type, index) {
      // this[`${type}Time`] = time
      // if (!time) {
      //   this.xhrParams.classTime = ''
      //   this.$refs.ruleForm.validateField('classTime')
      // }
      if (type == 'start') {
        this.xhrParams.classTimeList[index].startTime = time
      } else {
        this.xhrParams.classTimeList[index].endTime = time
      }
      if (this.xhrParams.classTimeList[index].startTime && this.xhrParams.classTimeList[index].endTime && this.xhrParams.classTimeList[index].startTime >= this.xhrParams.classTimeList[index].endTime) {
        this.$message.error('结束时间必须大于开始时间')
      } else if (this.xhrParams.classTimeList[index].startTime && this.xhrParams.classTimeList[index].endTime) {
        const startTime = this.startTime
          ? moment(this.xhrParams.classTimeList[index].startTime).format('HH:mm')
          : ''
        const endTime = this.xhrParams.classTimeList[index].endTime ? moment(this.xhrParams.classTimeList[index].endTime).format('HH:mm') : ''

      }
    },
    onChangeThree(item, index, user) {
      this.xhrParams.classTimeList[index].classTime = item
      this.xhrParams.classTimeList[index].endTime = true
      if (this.xhrParams.classTimeList[index].attendDate) {
        let isJudge = moment(this.xhrParams.classTimeList[index].attendDate).format("YYYY-MM-DD") + '/' + this.xhrParams.classTimeList[index].classTime
        // 拿到现在已存在课节的数据
        if (this.arrLessonList.has(isJudge)) {
          this.xhrParams.classTimeList[index].duplicate = true
        } else {
          this.xhrParams.classTimeList[index].duplicate = false
        }
      }
    },
    onChangeFour(item, index, user) {
      this.xhrParams.classTimeList[index].attendDate = item
      this.xhrParams.classTimeList[index].startTime = true
      if (this.xhrParams.classTimeList[index].classTime) {
        let isJudge = moment(this.xhrParams.classTimeList[index].attendDate).format("YYYY-MM-DD") + '/' + this.xhrParams.classTimeList[index].classTime
        // 拿到现在已存在课节的数据
        if (this.arrLessonList.has(isJudge)) {
          this.xhrParams.classTimeList[index].duplicate = true
        } else {
          this.xhrParams.classTimeList[index].duplicate = false
        }
      }
    },
    onFocusSelect(item, index, type) {
      if (type == 'start') {
        this.xhrParams.classTimeList[index].startTime = true
      } else if (type == 'end') {
        this.xhrParams.classTimeList[index].endTime = true
      }
    },
    changeonChange(time, type) {
      this[`change${type}Time`] = time
      if (!time) {
        this.form.classTime = ''
        this.$refs.ruleForm.validateField('classTime')
      }
      if (
        this.changestartTime &&
        this.changeendTime &&
        this.changestartTime >= this.changeendTime
      ) {
        this.$message.error('结束时间必须大于开始时间')
      } else if (this.changestartTime && this.changeendTime) {
        const changestartTime = this.changestartTime
          ? moment(this.changestartTime).format('HH:mm')
          : ''
        const changeendTime = this.changeendTime
          ? moment(this.changeendTime).format('HH:mm')
          : ''
        this.form.classTime = `${changestartTime}-${changeendTime}`
        this.$refs.ruleForm.clearValidate('classTime')
      }
    },
    removeUser(item) {
      let index = this.xhrParams.classTimeList.indexOf(item);
      let arr = [];
      if (this.xhrParams.classTimeList.length > 1) {
        // this.xhrParams.classTimeList.shift();
        this.xhrParams.classTimeList.splice(index, 1);
      } else {
        this.$message.error('至少需要保留一条')
      }
    },
    addUser() {
      this.xhrParams.classTimeList.push({ attendDate: '', classTime: undefined, startTime: false, endTime: false, id: Date.now() });
    },
    handleOk(e) {
      // this.confirmLoading = true
      // this.isShow = false
      // let isRepeat = ''
      // let newArr = ''
      let repeat = false
      let preRepeat = false
      this.classTimeList = [];
      this.errorList = [];
      this.TimeError = false;
      if (this.xhrParams.lessonType == 1) {
        for (var i = 0; i < this.xhrParams.classTimeList.length; i++) {
          this.xhrParams.classTimeList[i].startTime = true;
          this.xhrParams.classTimeList[i].endTime = true;
          if (!this.xhrParams.classTimeList[i].classTime || !this.xhrParams.classTimeList[i].attendDate) {
            this.errorList.push(true);
          }
        }
      }
      if (this.errorList.length > 0 && this.xhrParams.lessonType == 1) {
        return
      }
      this.$refs.ruleForm.validate((valid, value) => {
        // 表单的验证规则
        if (this.xhrParams.lessonType == 1) {
          if (this.xhrParams.classTimeList.length > 0) {
            for (let i = 0; i < this.xhrParams.classTimeList.length; i++) {
              this.xhrParams.classTimeList[i].attendDate = moment(this.xhrParams.classTimeList[i].attendDate).format('YYYY-MM-DD')
              this.classTimeList.push(this.xhrParams.classTimeList[i].attendDate + '/' + this.xhrParams.classTimeList[i].classTime)
            }
          }
        }


        //  新增课节的日期时间不能重复
        if ((this.classTimeList.length != new Set(this.classTimeList).size) && this.xhrParams.lessonType == 1) {
          var set = new Set()
          let choiceDuplicate = "";
          for (i = 0; i < this.classTimeList.length; i++) {
            if (set.has(this.classTimeList[i])) {
              choiceDuplicate += this.classTimeList[i] + ' , ';
            } else {
              set.add(this.classTimeList[i])
            }
          }
          this.$message.error('新增课节的日期时间不能重复:' + choiceDuplicate.slice(0, choiceDuplicate.length - 3))
          return
        }

        // 拿到现在已存在课节的数据

        let arrLessonList = new Set();
        this.lessonList.map((item) => {
          //item.attendDate = item.attendDate.slice(0, 10)
          arrLessonList.add(item.attendDate.slice(0, 10) + '/' + item.classTime);
        })

        // 新增课节的日期时间不能与已存在的课节重复
        let duplicate = "";
        for (let item in this.classTimeList) {
          if (arrLessonList.has(this.classTimeList[item])) {
            duplicate += this.classTimeList[item] + ' , ';
          }
        }
        //preRepeat = common.isRepeat([...this.classTimeList, ...arrLessonList])
        if (duplicate != "" && this.xhrParams.lessonType == 1) {
          this.$message.error('新增课节的日期时间不能与已存在的课节重复:' + duplicate.slice(0, duplicate.length - 3))
          return
        }



        if (valid) {
          let _this = this
          let { classTimeList, ...params } = { ...this.xhrParams }
          params.classId = this.classId
          if (params.attendDate) {
            params.attendDate = params.attendDate.format('YYYY-MM-DD')
          }
          if (params.lessonType === 0) {
            // const scheduleId = this.lessonList.filter(item => item.lessonId === params.lessonId)[0].scheduleId;
            // params.scheduleId = scheduleId;
            const lessonId = this.lessonList.filter(
              (item) => item.scheduleId === params.scheduleId
            )[0].lessonId
            params.lessonId = lessonId
            if (!params.lessonId) delete params.lessonId
            delete params.lessonName
          } else {
            delete params.lessonId
            delete params.scheduleId
          }
          if (_this.xhrParams.lessonType == 0) {
            classTimeList = []
          }
          params.classTimeList = this.classTimeList
          this.sendParamsClass(params)
          this.confirmLoading = false
        } else {
          this.confirmLoading = false
          return false
        }
      })
      // this.xhrParams.classTimeList = [{attendDate:undefined,startTime:'',endTime:''}]
    },
    getClassTimeList() {
      education.getClassTimeList().then((res) => {
        this.toClassList = res.data
      })
    },
    async deleteClass(record) {
      if (record.length === 0) {
        this.$message.warning('请选择')
        return
      }
      let arr = []
      if (Array.isArray(record)) {
        this.$confirm({
          title: '确定删除?',
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
            let res = await education.deleteClassRecording({
              scheduleId: record,
            })
            if (res.code === 0) {
              this.$message.success('删除成功')
              this.isShow = false
              this.getDetail(this.classId)
            }
          },
        })
      } else {
        arr.push(record.scheduleId)
        const data = await education.deleteClassRecording({ scheduleId: arr })
        if (data.code === 0) {
          this.$message.success('删除成功')
          this.isShow = false
          this.getDetail(this.classId)
        }
      }
    },
    disabledDate_attendDate(current) {
      return (
        current &&
        current <= moment(moment().format('YYYY-MM-DD') + ' 00:00:00')
      )
    },
    //修改上课时间
    updateTime(value) {
      this.visible_inner = true
      this.updateObj = value
      // this.form.lessonName = value.lessonName;
      //需要改成changestarttime和changeendtime
      this.form.classTime = this.updateObj.classTime
      this.changestartTime = moment(
        this.updateObj.classTime.split('-')[0],
        'HH:mm:ss'
      )
      this.changeendTime = moment(
        this.updateObj.classTime.split('-')[1],
        'HH:mm:ss'
      )

      this.form.attendDate = moment(value.attendDate)
    },
    postpone(item, index) {
      this.$confirm({
        title: '确定要顺延吗?',
        okText: '确定',
        cancelText: '取消',
        content: '顺延后，无法撤销',
        onOk: () => {
          education.postpone(item.scheduleId).then((res) => {
            this.getAfterSchool()
            this.$message.success('顺延成功')
          })
        },
      })
    },
    //查询放假信息：信息 + 课表列表
    getAfterSchool() {
      education.getClassDetail(this.classId).then((res) => {
        this.courseDetail = res.data
        this.lessonList = this.courseDetail.lessonList
        this.arrLessonList = new Set()
        this.lessonList.map((item) => {
          //item.attendDate = item.attendDate.slice(0, 10)
          this.arrLessonList.add(item.attendDate.slice(0, 10) + '/' + item.classTime);
        })
      })
    },
    //取消上课时间弹窗
    handleCancel_inner() {
      this.visible_inner = false
    },
    changeDate(a) {
      this.form.attendDate = a
    },
    handleSubmit_inner() {
      this.$refs.ruleForm.validate((err, value) => {
        //校验通过
        if (err) {
          let req = {
            attendDate: moment(this.form.attendDate).format('YYYY-MM-DD'),
            classTime: this.form.classTime,
            // lessonName: this.form.lessonName
          }
          education
            .updateClassTime(this.updateObj.scheduleId, req)
            .then((res) => {
              this.$message.success('修改成功')
              this.getAfterSchool()
              this.handleCancel_inner()
            })
        } else {
          console.log('error submit!!!')
          return false
        }
      })
    },
    // 日期选择范围
    disabledDate(current) {
      return current && current <= moment(moment().format('YYYY-MM-DD') + ' 00:00:00') || current && current > moment(this.termEndTime)
    },
    // 切换分页
    // changePage(page) {
    //   this.current = page.current - 1
    //   if (this.current == 0) {
    //     this.current = ''
    //   }
    // },
    downloadQrCode() {
      this.isDownload = true
      let params = {
        qrcode: this.qrCode,
        name: this.courseInfo.className
      }
      qywx.downloadChatQrcode(params).then(res => {
        const blob = new Blob([res.data], { type: 'image/png' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.courseInfo.className + '群二维码';
        document.body.appendChild(link);
        link.click();
        this.isDownload = false
        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 100);
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../config/var.scss';

.ant-page-header {
  padding: 0;
}

.df {
  display: flex;

}

/deep/ .ant-page-header-content {
  padding-top: 40px;
}

/deep/ td {
  padding: 10px 0 !important;
}

.table-top {
  margin-top: 32px;
  border-top: 1px solid rgba(0, 0, 0, 0.6);
  padding-top: 40px;
  padding-bottom: 16px;

  .table-top-left {
    font-weight: bold;
  }
}

.round {
  width: 6px;
  height: 6px;
  border-radius: 100%;
  display: inline-block;
  margin-right: 10px;
}

.disabled-round {
  background-color: $gray;
}

.success-round {
  background-color: $green;
}

.warning-round {
  background-color: $orange;
}

/deep/ .ant-popover-inner-content {
  padding: 12px 16px !important;
}

/deep/ .ant-descriptions-item {
  vertical-align: top;
}

/deep/ .ant-descriptions-item-label {
  vertical-align: top;
}

.newly-increased {
  display: flex;
  align-items: flex-start;
  height: 50px;
}

.newly-increased-classTime {
  display: flex;
  align-items: flex-start;
}

.newly-course {
  display: flex;
  align-items: flex-start;
}

.newly-course /deep/ .ant-form-item-label {
  width: 90px;
  text-align: right;
}

.newly-course /deep/ .ant-calendar-picker-input {
  margin-right: 10px;
}

.newly-picker {
  margin-right: 10px;
  width: 130px;
}

.newly-course /deep/ .anticon-delete {
  margin: 13px 0 0 10px;
}

.newly-course /deep/ .ant-form-item {
  margin-bottom: 1px;
  max-height: 250px;
  overflow-y: auto;
  margin-right: 0 !important;
}

.newly-increased /deep/ .ant-form-item {
  overflow-y: visible;
}

.newly-course /deep/ .ant-col-18 {
  width: 80%;
}

/deep/ .ant-modal-content {
  width: 550px;
}

.classTime-span {
  margin-top: 10px;
}

.newly-course-content {
  width: 370px;
}

// .newly-course /deep/ .ant-form-item-label> {
//   ::before {
//     display: inline-block;
//     margin-right: 4px;
//     color: #ff4d4f;
//     font-size: 14px;
//     font-family: SimSun, sans-serif;
//     line-height: 1;
//     content: '*';
//   }
// }

.newly-course .newly-course-name::before {
  // ::before {
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
  // }
}

.newly-course-name {
  margin-top: 6px;
  width: 95px;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  padding-left: 9px;
}

/deep/ .border-color {
  border-color: #f5222d;
}

.newly-picker {
  position: relative;
}

.choice {
  position: absolute;
  margin-top: -6px;
  color: #f5222d;
}

.newly-classTime /deep/ .ant-select-selection {
  border-color: #f5222d;
}



.newly-classTime /deep/ .ant-calendar-picker-input {
  border-color: #f5222d;
}

.newly-classTime /deep/ .ant-select-arrow-icon {
  color: #f5222d;
}

.newly-attendDate /deep/ .ant-input {
  border-color: #f5222d;
}

.newly-attendDate /deep/ .ant-input:hover {
  border-color: #f5222d;
}

.newly-add /deep/ .ant-form-item {
  text-align: right;
}

.newly-add /deep/ .ant-btn-block {
  width: 310px;
}

.newly-course-content /deep/ .ant-space-align-baseline {
  margin-bottom: 6px !important;
}

.qr-code {
  // width: 250px;
  min-height: 250px;
  margin-right: 10px;

  .pic {
    margin-bottom: 18px;
    box-shadow: 2px 4px 10px 2px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 10px;

    img {
      width: 230px;
      height: 230px;
      object-fit: cover;
    }
  }
}
</style>
